export var checkNewVersion = function (response) {
    var currentVersion = response.headers['release-version'];
    var lattestVersion = sessionStorage.getItem('release-version');
    sessionStorage.setItem('release-version', currentVersion);
    if (!lattestVersion)
        return false;
    return lattestVersion !== currentVersion;
};
//# sourceMappingURL=checkVersion.js.map